import { render, staticRenderFns } from "./modal-extend-booking.vue?vue&type=template&id=fefb07ac&scoped=true"
import script from "./modal-extend-booking.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal-extend-booking.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./modal-extend-booking.vue?vue&type=style&index=0&id=fefb07ac&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefb07ac",
  null
  
)

export default component.exports